import { Card, Skeleton, Typography } from 'antd';
import classNames from 'classnames';
import { memo } from 'react';

import MetricList from './metric-list';
import styles from './styles.module.scss';

import type { TProductivityGoalsProps } from './types';

const { Text } = Typography;

const ProductivityGoals = memo(
  ({
    title,
    metrics,
    className,
    isLoading = false,
  }: TProductivityGoalsProps) => (
    <Card
      className={classNames(styles['productivity-card'], className)}
      role="region"
      aria-label={title}
      variant="borderless"
    >
      {title && <Text className={styles['card-title']}>{title}</Text>}

      <Skeleton active loading={isLoading} paragraph={false}>
        <MetricList metrics={metrics} />
      </Skeleton>
    </Card>
  ),
);

ProductivityGoals.displayName = 'ProductivityGoals';

export default ProductivityGoals;
